import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import '../../CSS/Global.css';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';
import TestimonalModal from './TestmonialModal';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { decryptToken } from '../utils/getToken';
import { toast } from 'react-toastify';

const Testimonials = () => {
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [data, setData] = useState({
        heading: "",
        testomonial_message: "",
        user_name: "",
        // main_id: isLoggedIn.main_id,
    })
    const token = decryptToken("accessToken") || ""
    const url = API_BASE_URL;
    const [slider, setSlider] = useState([])
    const [load, setLoad] = useState(false);
    const sliderFetch = async () => {
        setLoad(true)
        try {
            const response = await fetch(`${url}/testomonial`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            })
            const res = await response.json();;
            setSlider(res);
        } catch (error) {
            console.error(error);
        } finally {
            setLoad(false)
        }
    }

    // Mock testimonials data
    const mockTestimonials = [
        {
            productName: "Wireless Headphones",
            customerName: "Alice Johnson",
            testimonialTitle: "Amazing sound quality!",
            starRating: 5,
            submittedAt: "2025-09-05 14:20",
        },
        {
            productName: "Smart Watch",
            customerName: "Bob Williams",
            testimonialTitle: "Great features but battery could be better",
            starRating: 4,
            submittedAt: "2025-09-06 10:45",
        },
        {
            productName: "Gaming Mouse",
            customerName: "Charlie Brown",
            testimonialTitle: "Responsive and comfortable",
            starRating: 5,
            submittedAt: "2025-09-07 18:30",
        },
        {
            productName: "Bluetooth Speaker",
            customerName: "Diana Prince",
            testimonialTitle: "Compact but powerful",
            starRating: 4,
            submittedAt: "2025-09-08 09:15",
        },
        {
            productName: "Laptop Stand",
            customerName: "Ethan Hunt",
            testimonialTitle: "Solid build, good angle",
            starRating: 5,
            submittedAt: "2025-09-09 20:05",
        },
    ];

    const [testimonialData, setTestimonialData] = useState(slider);

    const handleDelete = async (id) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this testimonial?");
        if (!confirmDelete) return;

        try {
            const response = await fetch(`${url}/testomonial/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            const res = await response.json();

            if (response.ok) {
                toast.success("Deleted successfully");
                sliderFetch(); // reload list
            } else {
                toast.error(res.message || "Failed to delete");
            }
        } catch (error) {
            console.error(error);
            toast.error("Something went wrong");
        }
    };

    // Pagination
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;
    const totalPages = Math.ceil(slider.length / rowsPerPage);

    const paginatedData = slider.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

    // Helper: render stars
    const renderStars = (count) => "★".repeat(count) + "☆".repeat(5 - count);


    useEffect(() => {
        sliderFetch();
    }, [])
    return (
        <>
            <div >
                <div className="oms-header">
                    <h1 className="dashboard-title">Testimonials</h1>
                  
                </div>

                {/* Desktop Table */}
                <div className="customer-table responsive-table">
                    <table>
                        <thead>
                            <tr>
                                <th>Heading</th>
                                <th>Customer</th>
                                <th>Testimonial</th>
                                {/* <th>Rating</th> */}
                                <th>Submitted At</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {paginatedData.length > 0 ? (
                                paginatedData.map((row, i) => (
                                    <tr key={i}>
                                        <td>{row.heading}</td>
                                        <td>{row.user_name}</td>
                                        <td>{row.testomonial_message}</td>
                                        <td>
                                            {new Date(row.createdAt).toLocaleString("en-IN", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </td>
                                        <td style={{ display: "flex", gap: "10px" }}>
                                            <button
                                                className="edit-button"
                                                onClick={() => {
                                                    setData(row);   // fill modal with data
                                                    setIsModalOpen(true);
                                                }}
                                            >
                                                <i className="fa-solid fa-pencil edit-oms"></i>
                                            </button>

                                            <button
                                                className="oms-delete-btn"
                                                onClick={() => handleDelete(row.id)}
                                            >
                                                <i className="fa-solid fa-trash delete-oms"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="5" style={{ textAlign: "center" }}>
                                        No testimonials yet.
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Mobile Cards */}
                <div className="ecom-responsive-cards">
                    {paginatedData.length > 0 ? (
                        paginatedData.map((row, i) => (
                            <div className="ecom-responsive-card" key={i}>
                                <div className="ecom-responsive-header">
                                    <p>
                                        <strong className='mr-1'>Submitted At:</strong> {row.submittedAt}
                                    </p>
                                </div>
                                <div className="ecom-responsive-body">
                                    <p>
                                        <strong>Product:</strong> {row.productName}
                                    </p>
                                    <p>
                                        <strong>Customer:</strong> {row.customerName}
                                    </p>
                                    <p>
                                        <strong>Testimonial:</strong> {row.testimonialTitle}
                                    </p>
                                    <p>
                                        <strong>Rating:</strong> {renderStars(row.starRating)}
                                    </p>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p style={{ textAlign: "center", margin: "50px" }}>
                            No testimonials yet
                        </p>
                    )}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => handlePageChange(1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronsLeft size={18} />
                        </button>
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="pagination-chev-btn"
                        >
                            <ChevronLeft size={18} />
                        </button>
                        <button className="pagination-btn active">{currentPage}</button>
                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronRight size={18} />
                        </button>
                        <button
                            onClick={() => handlePageChange(totalPages)}
                            disabled={currentPage === totalPages}
                            className="pagination-chev-btn"
                        >
                            <ChevronsRight size={18} />
                        </button>
                    </div>
                )}
            </div>
            <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50">
                <button
                    onClick={() => {
                        // Reset the form to default empty values
                        setData({

                            // main_id: isLoggedIn.main_id,
                            user_name: "",
                            testomonial_message: "",
                            heading: ""
                        });
                        setIsModalOpen(true);
                    }}
                    className="cssbuttons-io-button">
                    <span>Add</span>
                </button>
            </div>
            <TestimonalModal isOpen={isModalOpen} setIsOpen={setIsModalOpen} data={data} setData={setData} sliderFetch={sliderFetch} />
        </>
    );
};

export default Testimonials;
